export const isLocationStop = location =>
  location &&
  location.rawGeocodedFeature &&
  location.rawGeocodedFeature.properties &&
  location.rawGeocodedFeature.properties.layer &&
  location.rawGeocodedFeature.properties.layer.includes('stops');

export const getLocationStopId = location =>
  location &&
  location.rawGeocodedFeature &&
  location.rawGeocodedFeature.properties &&
  location.rawGeocodedFeature.properties.id &&
  location.rawGeocodedFeature.properties.id.split('::')[0];
